import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'a-gauge-bar',
    templateUrl: './a-gauge-bar.component.html',
    styleUrls: ['./a-gauge-bar.component.scss'],
    standalone: false
})
export class AGaugeBarComponent implements OnInit {

    @Input()
    public stateGauge: StateGauge = 'DEFAULT';
    public roundedValue: number;

    constructor() {
    }

    public fromStateGauge = fromStateGauge;

    @Input()
    public set value(value: number) {
        this.roundedValue = Math.round(value);
    }

    ngOnInit(): void {
    }
}

export type StateGauge = 'DEFAULT' | 'SUCCESS' | 'WARNING' | 'ALERT' | 'IN_PROGRESS';

export function fromStateGauge(stateGauge: StateGauge): string {
    switch (stateGauge) {
        case 'DEFAULT':
            return '_default';
        case 'SUCCESS':
            return '_success';
        case 'WARNING':
            return '_warning';
        case 'ALERT':
            return '_alert';
        case 'IN_PROGRESS':
            return '_in_progress';
    }
}
